/**
 * How the user resolved a proposed inline edit.
 *
 * The values are the wire contract for the existing Amplitude event and must not change.
 */
export enum InlineEditResolvedAction {
  Replaced = 'replaced',
  InsertedBelow = 'inserted_below',
  Declined = 'declined',
  NoDiff = 'no_diff',
}
